import React from 'react'
import { Typewriter } from 'react-simple-typewriter'

function Type({ titles }) {
  return (
    <Typewriter
      words={titles}
      loop={0}
      typeSpeed={80}
      deleteSpeed={50}
      delaySpeed={1500}
      cursor
      cursorStyle="|"
    />
  )
}

export default Type